import { Module } from 'vuex'

import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState, MultiUserState } from '@/types/store'
import { UserRole } from '@/types/user'

const state: MultiUserState = {
  multiUser: {
    id: -1,
    role: UserRole.LINKER,
    code: '',
    castId: '',
    castName: '',
    mail: '',
    password: '',
    isValid: true,
    isRewarded: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    deletedAt: null,
  },
  multiUsers: [],
  total: -1,
  searchCondition: {
    id: null,
    code: null,
    castId: null,
    castName: null,
    role: null,
  },
  isMultiUsersLoading: false,
}

export const multiUser: Module<MultiUserState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
